import { EstadosFacturaLiquidaciones } from "../../const/constantes"
import EstadosFactura from "../domain/EstadosFactura"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class EstadosFacturaService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getEstadosFactura() {
    const estadosData = await this.apiService.fetchEstadosFacturas()

    const listadoEstados= estadosData.map( 
      (estado) => 
        new EstadosFactura(
          estado.intIdEstadoLiquidacionWeb,
          estado.varDescripcion
        )
    ).filter(estado => estado.id!== EstadosFacturaLiquidaciones.PENDIENTETL && estado.id!== EstadosFacturaLiquidaciones.RECHAZADAAMODIFICAR)

    return listadoEstados
  }
}

export default EstadosFacturaService
